module.exports = __webpack_public_path__ + "media/images/emblems/Coat_of_arms_of_Oftringen-7578aad046be45fa7438a51621802b4b.svg";